import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _methods;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import prowerSetting from '@/components/power/prowerSetting';
import { mapGetters } from 'vuex';
import { getAlarmData, getMonitorList as _getMonitorList, getAlarmDetail, getHistory, alarmDateList } from '@/api/deviceOverview/alarm';
import { dictList } from '@/api/deviceOverview/file';

var moment = require('moment');

export default {
  name: 'alarmData',
  data: function data() {
    return {
      searchVal: '',
      gatewayId: '',
      tableData: [],
      variateOptions: [],
      installTime: [],
      monitorId: '',
      current: 1,
      size: 10,
      total: 0,
      title: this.$t('manipulation.sawBack'),
      dialogStationVisible: false,
      unit: '',
      curRow: {},
      loading: false,
      startdate: '',
      enddate: '',
      currentPage: 1,
      totals: 0,
      tableData1: [],
      typeList: [],
      flaglist: [{
        label: this.$t('alarmData.notProcessed'),
        value: '0'
      }, {
        label: this.$t('alarmData.processed'),
        value: '1'
      }],
      handleFlag: '',
      devNumber: ''
    };
  },
  created: function created() {
    this.gatewayId = this.stationObj.gatewayId;
    this.startdate = moment().startOf('month').format('YYYY-MM-DD');
    this.enddate = moment().format('YYYY-MM-DD');
    this.queryAlarmData(); //    this.getdictList()

    this.getMonitorList();
  },
  components: {// prowerSetting
  },
  computed: _objectSpread({}, mapGetters(["stationObj"])),
  methods: (_methods = {
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.currentPage = val;
      this.queryAlarmData();
    },
    // 监控点列表
    getMonitorList: function getMonitorList() {
      var _this = this;

      _getMonitorList().then(function (res) {
        if (res.data.code == 200) {
          _this.typeList = res.data.data;
        }
      });
    },
    getdictList: function getdictList() {
      var _this2 = this;

      // 空调
      dictList({
        code: "device_model"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.typeList = res.data.data[0].children;
        }
      });
    },
    seeMore: function seeMore(row) {
      console.log(row, '---');
    },
    init: function init() {
      this.installTime = [];
    },
    handleClose: function handleClose() {
      this.init();
      this.dialogStationVisible = false;
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("this.$t('alarmData.everyPage') ".concat(val, " this.$t('alarmData.strip')"));
      this.size = val;
      this.current = 1;
      this.searchHistory(this.curRow);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("this.$t('alarmData.currentPage') ".concat(val));
      this.current = val;
      this.searchHistory(this.curRow);
    },
    queryAlarmDateList: function queryAlarmDateList() {
      var _this3 = this;

      var obj = {};
      var row = this.curRow;
      var that = this;
      alarmDateList({
        alarmId: row.alarmId
      }).then(function (res) {
        if (res.data.code === 200) {
          console.log(res.data.data);

          for (var i = 0; i < res.data.data.length; i++) {
            obj[res.data.data[i]] = '';
          }

          laydate.render({
            elem: '#orderStartTime',
            mark: obj,
            zIndex: 99999999,
            trigger: 'click',
            done: function done(value, date) {
              that.startdate = value;
            }
          });
          laydate.render({
            elem: '#orderEndTime',
            zIndex: 99999999,
            mark: obj,
            type: 'date',
            trigger: 'click',
            done: function done(value, date) {
              that.enddate = value;
            }
          });
        } else {
          _this3.$message.error(res.data.msg);

          return;
        }
      });
    },
    searchHistory: function searchHistory(row) {
      var _this4 = this;

      this.loading = true;
      var obj = {
        alarmId: this.curRow.alarmId,
        streamId: this.curRow.streamId,
        onenetId: this.curRow.onenetId,
        devCode: this.curRow.devCode,
        current: this.current,
        size: this.size
      }; // this.queryAlarmDateList()

      if (this.installTime && this.installTime.length > 0) {
        obj.beginTime = moment(this.installTime[0]).format('YYYY-MM-DD');
        obj.endTime = moment(this.installTime[1]).format('YYYY-MM-DD');
      }

      getHistory(obj).then(function (res) {
        _this4.loading = false;

        if (res.data.code === 200) {
          console.log(res.data.data);
          res.data.data.records.map(function (item, index) {
            item.index = index + 1;
          });
          _this4.tableData1 = res.data.data.records; // let xAxisAry = [],sAry =[]
          // data.forEach(item=>{
          //     xAxisAry.push(item.time)
          //     sAry.push(item.value)
          // })

          _this4.total = res.data.data.total; // this.rendCharts(xAxisAry,sAry)
        } else {
          _this4.$message.error(res.data.msg);

          return;
        }
      });
    },
    viewHandle: function viewHandle(row) {
      this.unit = row.unit;
      this.curRow = row;
      this.title = row.alarmName; // + row.alarmLevelName

      this.dialogStationVisible = true;
      this.searchHistory(row);
    },
    // rendOptions (data) {
    //     let ary =[]
    //     data.map(item=>{
    //         let obj = {}
    //         obj.monitorName = item.alarmName
    //         obj.streamId = item.streamId
    //         ary.push(obj)
    //     })
    //     this.variateOptions = ary
    // },
    // selectStation (data) {
    //     console.log(data,'===daata')
    //     this.gatewayId = data.gatewayId
    //     this.queryAlarmData()
    // },
    getPage: function getPage() {},
    drawBarChart: function drawBarChart(id, options) {
      var myChart = echarts.init(document.getElementById(id)); // 使用 aidState做填充，fakeState显示小线条

      myChart.showLoading({
        text: this.$t('alarmData.loading') + "..."
      });
      myChart.hideLoading();
      myChart.setOption(options, window.onresize = myChart.resize);
    },
    rendCharts: function rendCharts(xAxisAry, seriesAry) {
      var options = {
        xAxis: {
          type: 'category',
          data: xAxisAry
        },
        grid: {
          left: '4%',
          right: '4%',
          bottom: '6%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          name: this.$t('alarmData.loading') + ":" + this.unit,
          minInterval: 1
        },
        series: [{
          data: seriesAry,
          type: 'line'
        }]
      };
      this.drawBarChart('echartHistory', options);
    }
  }, _defineProperty(_methods, "seeMore", function seeMore(row) {
    var _this5 = this;

    getAlarmDetail({
      id: row.alarmId
    }).then(function (res) {
      if (res.data.code === 200) {
        _this5.$alert(res.data.data.solution || _this5.$t('dataAnalysis.none'), '', {
          confirmButtonText: _this5.$t('manipulation.sure')
        });
      } else {
        _this5.$message.error(res.data.msg);

        return;
      }
    });
  }), _defineProperty(_methods, "search", function search() {
    this.currentPage = 1;
    this.queryAlarmData();
  }), _defineProperty(_methods, "refresh", function refresh() {
    this.monitorId = '';
    this.handleFlag = '';
    this.devNumber = '';
    this.currentPage = 1;
    this.queryAlarmData();
  }), _defineProperty(_methods, "queryAlarmData", function queryAlarmData() {
    var _this6 = this;

    var current = this.current,
        size = this.size,
        monitorId = this.monitorId,
        handleFlag = this.handleFlag,
        devNumber = this.devNumber,
        gatewayId = this.gatewayId; // monitorId,

    getAlarmData({
      streamId: monitorId,
      handleFlag: handleFlag,
      devNumber: devNumber,
      gatewayId: gatewayId,
      size: 10,
      current: this.currentPage
    }).then(function (res) {
      if (res.data.code === 200) {
        res.data.data.records.map(function (item, index) {
          item.index = index + 1;
        });
        _this6.tableData = res.data.data.records;
        _this6.currentPage = res.data.data.current;
        _this6.totals = res.data.data.total; //    this.rendOptions(this.tableData)
      } else {
        _this6.$message.error(res.data.msg);

        return;
      }
    });
  }), _methods),
  mounted: function mounted() {
    var that = this;
  }
};